import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

interface ChartContainerProps {
  title?: string;
  description?: string;
  loading?: boolean;
  height?: number | 'auto';
  children: React.ReactNode;
  className?: string;
  action?: React.ReactNode;
}

export default function ChartContainer({
  title,
  description,
  loading = false,
  height = 280,
  children,
  className,
  action,
}: ChartContainerProps) {
  if (loading) {
    return (
      <Card className={className}>
        {title && (
          <CardHeader className="pb-2">
            <Skeleton className="h-5 w-32" />
            {description && <Skeleton className="h-4 w-48 mt-1" />}
          </CardHeader>
        )}
        <CardContent>
          <Skeleton className="w-full" style={{ height }} />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className={cn(className)}>
      {(title || action) && (
        <CardHeader className="pb-2">
          <div className="flex items-center justify-between">
            <div>
              {title && <CardTitle className="text-base">{title}</CardTitle>}
              {description && <CardDescription>{description}</CardDescription>}
            </div>
            {action}
          </div>
        </CardHeader>
      )}
      <CardContent>
        <div style={height === 'auto' ? undefined : { height }}>{children}</div>
      </CardContent>
    </Card>
  );
}
